import { ModelBase } from 'store/model-base';

export class NowBuyFlow extends ModelBase {
    public static storeName: string = 'nowBuyFlow';

    public buyFlowRedirect: string;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowBuyFlow = super.create<NowBuyFlow>(initData);

        return super.create<T>(toReturn);
    }
}
